import React, { useState, useEffect } from 'react';
import ReactApexChart from 'react-apexcharts';
import axios from 'axios';

const OutStandingQueries = ({ filter, fetchedData,series,categories }) => {
  // const [series, setSeries] = useState([]);
  // const [categories, setCategories] = useState([]);

//     useEffect(() => {
//         if(fetchedData){
//  fetchData();
//         }
       
//     }, [fetchedData]);

//   const fetchData = async () => {
//     try {
//       const response = await axios.get(
//         `${process.env.REACT_APP_API_URL}/api/Dashboard/DashboardOutstandingQueries?Month=${filter?.month}&Year=${filter?.year}`,
//         {
//           headers: {
//             'Content-Type': 'application/json',
//             Authorization: `Bearer ${localStorage.getItem('user_token')}`,
//           },
//         }
//       );

//       const data = response?.data?.response;

//       // Extract categories from the `name` field
//       const names = data.map(item => item.name);

//       // Prepare series data
//       const lessThan3Days = data.map(item => parseInt(item.lessThan3Days, 10));
//       const lessThan7Days = data.map(item => parseInt(item.lessThan7Days, 10));
//       const moreThan7Days = data.map(item => parseInt(item.moreThan7Days, 10));

//       setCategories(names);
//       setSeries([
//         {
//           name: '0-3 Days',
//           data: lessThan3Days,
//         },
//         {
//           name: '4-7 Days',
//           data: lessThan7Days,
//         },
//         {
//           name: 'More than 7 Days',
//           data: moreThan7Days,
//         },
//       ]);
//     } catch (error) {
//       console.error('Failed to fetch data:', error);
//     }
//   };

  const options = {
    chart: {
      id: 'bar-chart',
      type: 'bar',
      height: 350,
      toolbar: {
        show: false,
      },
    },
    plotOptions: {
      bar: {
        horizontal: false,
        columnWidth: '55%',
      },
    },
    dataLabels: {
      enabled: false,
    },
    xaxis: {
      categories: categories,
    },
    legend: {
      position: 'top',
    },
    colors: ['#1E90FF', '#32CD32', '#FFA500'],
  };

  return (
    <div className="chart">
      <ReactApexChart options={options} series={series} type="bar" height={350} />
    </div>
  );
};

export default OutStandingQueries;
